import React from 'react';

// Inset by the rows' px-2.5 so the divider starts on the icon column and ends evenly on the right.
const MenuDivider = ({ className = '' }) => (
  <div className={`my-1.5 h-[0.5px] w-[calc(100%-20px)] self-center bg-gray-800/10 dark:bg-neutral-200/10 ${className}`} />
);

export default MenuDivider;
